export { default } from "@features/investments/screens/help-screen";
